/**
 *Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import Indicator from "../Indicator";
import InputGlobal from "../InputGlobal";
import { validateEmail, simplyClick } from "../../helpers";
import ButtonGroup from "../ButtonGroup";
import cn from "classnames";

/**
 *Assets
 */
import skinnyIcon from "../../images/ico_skinny.svg";
import averageIcon from "../../images/ico_average.svg";
import modelIcon from "../../images/ico_model.svg";
import plusIcon from "../../images/ico_plus-size.svg";
import BigIcon from "../../images/ico_big.svg";
import dontCareIcon from "../../images/ico_question-mark.svg";

/**
 *Styles
 */
import "./Email.scss";
import {
  errorEventsEmail,
  IS_VISIBLE_CUSTOM_AUTOCOMPLETE,
  bodyTypes,
  ERROR_EMAIL_ALREADY_USED,
  landingId,
} from "../../constants";
import CustomEmailAutoComplete from "../CustomEmailAutoComplete";
import Tooltip from "../Tooltip";
import LoaderEmail from "../LoaderEmail";
import { useWizardAnswers } from "ui-components";

const Email = ({ step, setStep }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorEmail, setErrorEmail] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [loaderTextMain, setLoaderTextMain] = useState("");
  const [loaderTextSub, setLoaderTextSub] = useState("");
  const [selectedIndicator, setSelectedIndicator] = useState(null);

  const updateAnswer = useWizardAnswers();

  const handlerSubmit = () => {
    if (!selectedIndicator) {
      updateAnswer({ body_type: ["0"] });
    }
    setLoader(true);
    setLoaderTextMain("Checking your email...");
    setLoaderTextSub("This might take a moment.");

    const textTimeout = setTimeout(() => {
      setLoaderTextMain("Still checking your email...");
      setLoaderTextSub("Thanks for your patience!");
    }, 3000);

    validateEmail(data.email, (result) => {
      const { status, error } = result;
      setLoader(false);
      if (!status && error) {
        const analyticsEvent = errorEventsEmail[error];
        if (analyticsEvent) {
          simplyClick(analyticsEvent);
        }
        setErrorEmail(error);
        return;
      }
      setStep(step + 1);
    });
  };

  const handlerStepBack = () => {
    simplyClick("cl_lnd_cd3_email_back");
    setStep(step - 1);
  };

  const handleAddEmail = (e) => {
    setEmailValue(e.target.value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setShowTooltip(false);
    setData({ ...data, email: value });
  };
  const handleSelectIndicator = (id) => {
    const selected = bodyTypes[id];

    if (!selected) {
      return;
    }

    setSelectedIndicator(selected.label);
    updateAnswer({ body_type: [String(id)] });

    if (selected.event) {
      simplyClick(selected.event);
    }
  };
  const handlerEmailFocus = () => {
    setShowTooltip(true);
    simplyClick("cl_lnd_cd3_email_type_email");
  };
  return (
    <>
      {loader && (
        <LoaderEmail textMain={loaderTextMain} textSub={loaderTextSub} />
      )}
      <div className="global__form-wrap">
        <div className="email__form">
          <h5 className="form__title">
            What body type you find most attractive?
          </h5>
          <div className="group__top">
            <Indicator
              textLabel={bodyTypes[1].label}
              iconIndicator={skinnyIcon}
              className="component-1"
              isActive={selectedIndicator === bodyTypes[1].label}
              onClick={() => handleSelectIndicator(1)}
            />
            <Indicator
              textLabel={bodyTypes[2].label}
              iconIndicator={modelIcon}
              className="component-2"
              isActive={selectedIndicator === bodyTypes[2].label}
              onClick={() => handleSelectIndicator(2)}
            />
            <Indicator
              textLabel={bodyTypes[3].label}
              iconIndicator={averageIcon}
              className="component-3"
              isActive={selectedIndicator === bodyTypes[3].label}
              onClick={() => handleSelectIndicator(3)}
            />
          </div>

          <div className="group__bottom">
            <Indicator
              textLabel={bodyTypes[4].label}
              iconIndicator={plusIcon}
              className="component-4"
              isActive={selectedIndicator === bodyTypes[4].label}
              onClick={() => handleSelectIndicator(4)}
            />
            <Indicator
              textLabel={bodyTypes[5].label}
              iconIndicator={BigIcon}
              className="component-5"
              isActive={selectedIndicator === bodyTypes[5].label}
              onClick={() => handleSelectIndicator(5)}
            />
            <Indicator
              textLabel={bodyTypes[6].label}
              iconIndicator={dontCareIcon}
              className="component-6"
              isActive={selectedIndicator === bodyTypes[6].label}
              onClick={() => handleSelectIndicator(6)}
            />
          </div>
          <span className="line" />
          <h5 className="form__title">Enter your email*</h5>
          <div className="email_input">
            <div className="has-float-label">
              <InputGlobal
                className={cn("input__global", {
                  error: errorEmail,
                  active:
                    data.email?.length > 0 &&
                    !data.email?.includes("@") &&
                    IS_VISIBLE_CUSTOM_AUTOCOMPLETE,
                })}
                onChange={(e) => handleAddEmail(e)}
                name={"email"}
                placeholder={"Enter your real email address"}
                type={"text"}
                id={"email__30"}
                value={data.email ? data.email : ""}
                autoComplete="email"
                onFocus={handlerEmailFocus}
                onBlur={() => setShowTooltip(false)}
              />
              <label htmlFor="email__30" className={errorEmail ? "error" : ""}>
                Enter your real email address
              </label>
              {IS_VISIBLE_CUSTOM_AUTOCOMPLETE && (
                <CustomEmailAutoComplete
                  errorEmail={errorEmail}
                  errorCb={() => setErrorEmail(null)}
                />
              )}

              {errorEmail && <p className="error-text">{errorEmail}</p>}
              {errorEmail === ERROR_EMAIL_ALREADY_USED && (
                <div className="extra-info">
                  <p>
                    <a
                      href={`/login/?landing_id=${landingId}${
                        data?.email
                          ? `&email=${encodeURIComponent(data.email)}`
                          : ""
                      }`}
                      id="login-link"
                      onClick={() => {
                        sessionStorage.setItem("email", data.email);
                        sessionStorage.setItem("fromLogin", "1");
                        simplyClick("cl_lnd_cd3_againemail_login");
                      }}
                    >
                      Log in
                    </a>
                    &nbsp;or use another email.
                  </p>
                </div>
              )}
            </div>
            <Tooltip
              text="We'll use this email for account verification and important notifications."
              showTooltip={showTooltip}
              className="email"
            />
          </div>
        </div>
        <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
      </div>
    </>
  );
};
export default Email;
